import SwiperSlider from '../../../Elements/SwiperSlider';
import {$window} from '../../../Constants';

/**
 * GallerySlider
 */
const GallerySlider = (() => {
	/**
	 * Gallery
	 *
	 * @var { Object }
	 */
	const Selector = {
		GALLERY_SLIDER: '.gallery-slider.swiper-container',
	};

	/**
	 * Class Name
	 *
	 * @var { Object }
	 */
	const ClassName = {
		CAN_CENTER: 'can-center'
	};

	/**
	 * GallerySlider
	 *
	 * @class
	 * @augments SwiperSlider
	 */
	class GallerySlider extends SwiperSlider {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			this.setOptions({
				spaceBetween: 30,
				slidesPerView: this.$element.data('cols-large'),
				grabCursor: true,
				pagination: {
					el: this.constructor.Selector.PAGINATION,
					clickable: true
				},
				navigation: {
					nextEl: this.$element.parent().find('.swiper-button-next').get(0),
					prevEl: this.$element.parent().find('.swiper-button-prev').get(0)
				},
				autoplay: {
					delay: 5000,
					disableOnInteraction: false
				},
				loop: this.length > parseInt(this.$element.data('cols-large')),
				breakpoints: {
					1000: {
						slidesPerView: this.$element.data('cols-medium'),
						loop: this.length > parseInt(this.$element.data('cols-medium'))
					},
					500: {
						slidesPerView: 1,
						loop: true
					}
				},
				// Disable preloading of all images
				preloadImages: false,
				// Enable lazy loading
				lazy: {
					enabled: true,
					loadOnTransitionStart: true,
					checkInView: true
				}
			});

			this._initialize();
			this._bindHandlers();
			this._handleCentering();
		}

		/**
		 * Binds the event handlers to the elements
		 *
		 * @return void
		 */
		_bindHandlers() {
			$window.on('resize', () => {
				this._handleCentering();
			});
		}

		/**
		 * Handles the centering by adding or removing the css class
		 *
		 * @return void
		 */
		_handleCentering() {
			this.$element.toggleClass(ClassName.CAN_CENTER, this.length < this.slider.params.slidesPerView);
		}
	}

	return GallerySlider._getElements(Selector.GALLERY_SLIDER, GallerySlider);
})();

export default GallerySlider;
